import { take, takeLatest } from "redux-saga/effects";
import { Types as AllTypes } from "../../actions";
import { Creators } from "../../actions/common";
import { LoadAction } from "../../actions/load-amounts";
import * as actions from "../../actions/load-amounts";
import {
  fetchAllOrganizations,
  loadClassAmount,
  loadCourseAmount,
  loadExportedSCORMPackages,
  loadGroupsAmount,
  loadUsersAmount,
  selectOrganization,
  updateCoursesAmount,
} from "../../actions/organizations";

const Types = (AllTypes as any)._APP._SELECT_ORGANIZATION;

export function* watchFetchAllOrganizations() {
  yield takeLatest(
    Types.FETCH_ALL_ORGANIZATIONS,
    fetchAllOrganizations({
      onFailure: Creators.handleFetchAllOrganizationsFailure,
      onSuccess: Creators.handleFetchAllOrganizationsSuccess,
    })
  );
}

export function* watchSelectOrganization() {
  yield takeLatest(
    Types.SELECT_ORGANIZATION,
    selectOrganization({
      onFailure: Creators.handleSelectOrganizationSuccess,
      onSuccess: Creators.handleSelectOrganizationSuccess,
    })
  );
}

export function* watchLoadClassAmount() {
  yield takeLatest(Types.LOAD_CLASS_AMOUNT, loadClassAmount(Creators.handleLoadClassAmount));
}

export function* watchLoadCourseAmount() {
  yield takeLatest(Types.LOAD_COURSE_AMOUNT, loadCourseAmount(Creators.handleLoadCourseAmount));
}

export function* watchLoadExportedSCORMPackagesAmount() {
  yield takeLatest(
    LoadAction.LOAD_EXPORTED_SCORM_PACKAGES_AMOUNT,
    loadExportedSCORMPackages(actions.handleLoadExportedSCORMPackagesAmount)
  );
}

export function* watchUpdateCoursesAmount() {
  yield takeLatest(Types.UPDATE_COURSES_AMOUNT, updateCoursesAmount(Creators.handleUpdateCoursesAmount));
}

export function* watchLoadGroupsAmount() {
  yield takeLatest(Types.LOAD_GROUPS_AMOUNT, loadGroupsAmount(Creators.handleLoadGroupsAmount));
}

export function* watchLoadUsersAmount() {
  yield takeLatest(Types.LOAD_USERS_AMOUNT, loadUsersAmount(Creators.handleLoadUsersAmount));
}

export function* watchMount() {
  yield take(Types.MOUNT);
}

export function* watchUnmount() {
  yield take(Types.UNMOUNT);
}
